export enum BulkActions {
    Deactivate = 0,
    SendReminderEmail = 1,
    ChangeStatus = 2
}